import {connect} from "react-redux";
import {AccountBlockedComponent} from "./accountBlocked.component";
import {getError} from "../../store/selectors/app.selectors";

const mapStateToProps = (state) => {
	return {
		error: getError(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {

	};
};

export const AccountBlockedRoute = connect(
	mapStateToProps,
	mapDispatchToProps
)(AccountBlockedComponent);
